import { ButtonLink } from '@components/ui/Button'
import styles from './styles.module.scss'
import { FIT_FINDER_HASH } from '@consts/index'
import { getUserSavedFitData } from '@helpers/session/user'
import { getHelpdeskLink, getLink, prefixLocale } from '@helpers/env'
import MenuLink from '@components/Header/shared/MenuLink'
import { analytics } from '@helpers/analytics'
import { HEADER_ANALYTICS_EVENT_NAMES } from '@components/Header/consts'
import { useLogin } from '@api/accounts/auth/hooks/useLogin'
import ButtonMinimal from '@components/ui/Button/ButtonMinimal'
import { useRouter } from 'next/router'
import { ACCOUNT_PAGE_NAME } from '@api/accounts/auth/consts'

export default function SecondaryMenuLinks() {
  const router = useRouter()
  const { login, isLoggedIn } = useLogin()
  const userHasSavedFitCookies = getUserSavedFitData()
  const isNewAccountPages = process.env.NEW_ACCOUNT_PAGES_ENABLED === 'true'

  const goToAccountPage = () => {
    analytics('Click', {
      category: HEADER_ANALYTICS_EVENT_NAMES.category.nav,
      label: 'My Account'
    })

    if (isNewAccountPages && !isLoggedIn) {
      login()
    } else {
      const accountUrl = isNewAccountPages
        ? `${prefixLocale()}/${ACCOUNT_PAGE_NAME}?page=overview`
        : `${prefixLocale()}/${ACCOUNT_PAGE_NAME}`
      router.push(accountUrl)
    }
  }

  return (
    <ul className={styles.SecondaryMenuLinks}>
      <li className={styles.SecondaryMenuLinks__button}>
        <ButtonLink
          href={`#${FIT_FINDER_HASH}`}
          rawHref={true}
          data-testid="fitfinder-desktop-nav-button"
          variant="secondary"
          classes={styles.fitFinderMenuLink}
          onClick={() => {
            analytics('Click', {
              category: HEADER_ANALYTICS_EVENT_NAMES.category.nav,
              label: 'My Fit'
            })
          }}
        >
          {userHasSavedFitCookies ? 'My Fit' : 'Find your Fit'}
        </ButtonLink>
      </li>
      <li>
        <ButtonMinimal
          textSize="large"
          onClick={goToAccountPage}
          classes={styles.accountMenuLink}
        >
          My Account
        </ButtonMinimal>
      </li>
      <li>
        <MenuLink
          link={getHelpdeskLink()}
          title="FAQs"
          target="_blank"
          onClick={() => {
            analytics('Click', {
              category: HEADER_ANALYTICS_EVENT_NAMES.category.nav,
              label: 'FAQs'
            })
          }}
          variant="secondary"
        />
      </li>
      <li>
        <MenuLink
          link={getLink('/pages/returns')}
          title="Returns"
          onClick={() => {
            analytics('Click', {
              category: HEADER_ANALYTICS_EVENT_NAMES.category.nav,
              label: 'Returns'
            })
          }}
          variant="secondary"
        />
      </li>
      <li>
        <MenuLink
          link={getLink('/pages/contact-us')}
          title="Contact Us"
          onClick={() => {
            analytics('Click', {
              category: HEADER_ANALYTICS_EVENT_NAMES.category.nav,
              label: 'Contact Us'
            })
          }}
          variant="secondary"
        />
      </li>
    </ul>
  )
}
